var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.07292 18.5834C6.29052 18.5834 5.65625 19.2176 5.65625 20C5.65625 20.5063 5.92186 20.9506 6.32133 21.2011L10.1288 25.0085C10.682 25.5619 11.579 25.5619 12.1323 25.0085C12.6855 24.4553 12.6855 23.5583 12.1323 23.0051L10.5439 21.4167H21.2397C22.0219 21.4167 22.6563 20.7824 22.6563 20C22.6563 19.2176 22.0219 18.5834 21.2397 18.5834H7.14297C7.13005 18.5832 7.11713 18.5832 7.10421 18.5834H7.07292Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.927 15.7945C27.7094 15.7945 28.3437 15.1603 28.3437 14.3778C28.3437 13.8715 28.0782 13.4272 27.6787 13.1767L23.8713 9.36927C23.3179 8.81604 22.421 8.81604 21.8677 9.36927C21.3145 9.92252 21.3145 10.8195 21.8677 11.3728L23.4562 12.9611H12.7604C11.978 12.9611 11.3438 13.5954 11.3438 14.3778C11.3438 15.1603 11.978 15.7945 12.7604 15.7945H26.857C26.8699 15.7946 26.8828 15.7946 26.8958 15.7945H26.927Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchArrowIcon);
export default __webpack_public_path__ + "static/media/switchArrowIcon.0dcde655a3ad0be3270737f48119ec79.svg";
export { ForwardRef as ReactComponent };